import React from "react";
import { Row, Col, Badge } from "reactstrap";

const NotFound = _ => {
	return (
		<Row className="justify-content-center">
			<Col xs="auto">
				<Badge
					className="bg-light text-dark p-5 shadow mt-5"
					style={{ fontSize: 24 }}
				>{`<404/> Page Not Found`}</Badge>
			</Col>
		</Row>
	);
};

export default NotFound;
